import React from "react";

import { Toolbar, Typography } from "@material-ui/core";

import "./App.css";

const Footer: React.FC = () => {
  return (
    <Toolbar className="App-footer">
      <Typography variant="body1">© Fortek 2020</Typography>
    </Toolbar>
  );
};

export default Footer;
